function calculate(
  minSize: number,
  maxSize: number,
  minBreakpoint = 390,
  maxBreakpoint = 1512
) {
  const slope = (maxSize - minSize) / (maxBreakpoint - minBreakpoint);
  const slopeVw = (slope * 100).toFixed(2); // in vw units
  const intercept = (minSize - slope * minBreakpoint).toFixed(2); // in px

  return `clamp(${minSize}px, ${slopeVw}vw + ${intercept}px, ${maxSize}px)`;
}

export const clamp = { calculate };